const ENTITY_STATUS = {
  EXPIRED: { value: 'expired', name: 'Expired' },
  DRAFT: { value: 'draft', name: 'Draft' },
  COMPLETED: { value: 'completed', name: 'Completed' },
  PASSED: { value: 'passed', name: 'Passed' },
  PUBLISHED: { value: 'published', name: 'Published' },
};

export default ENTITY_STATUS;
